import './GDPR.scss'

const GDPR = () => {
  return (
    <div className="gdpr-section">
      <div className="section-content">
        <div className="gdpr-header">
          <h2>Ochrana osobních údajů (GDPR)</h2>
          <p>Transparentní informace o zpracování vašich osobních údajů</p>
          <div className="last-updated">
            <span className="update-icon">📅</span>
            <span>Poslední aktualizace: 1. srpna 2025</span>
          </div>
        </div>

        <div className="gdpr-content">
          <div className="gdpr-block">
            <h3>1. Správce osobních údajů</h3>
            <div className="contact-info">
              <p><strong>Autoškola Příkaský</strong></p>
              <p>Josef Příkaský</p>
              <p>Husova 370, 697 01 Kyjov</p>
              <p>Telefon: 728 108 824</p>
              <p>Email: josef.prikasky@seznam.cz</p>
            </div>
          </div>

          <div className="gdpr-block">
            <h3>2. Jaké osobní údaje zpracováváme</h3>
            <p>Prostřednictvím kontaktního formuláře na našich webových stránkách zpracováváme:</p>
            <ul>
              <li>Jméno a příjmení</li>
              <li>Emailová adresa</li>
              <li>Telefonní číslo</li>
              <li>Typ požadovaného kurzu</li>
              <li>Zpráva (nepovinné)</li>
            </ul>
          </div>

          <div className="gdpr-block">
            <h3>3. Účel zpracování osobních údajů</h3>
            <p>Vaše osobní údaje zpracováváme za účelem:</p>
            <ul>
              <li>Kontaktování vás ohledně vaší poptávky po autoškolních službách</li>
              <li>Poskytování informací o našich kurzech a službách</li>
              <li>Sjednání termínu pro zahájení kurzu</li>
              <li>Administrativa související s vedením kurzu</li>
            </ul>
          </div>

          <div className="gdpr-block">
            <h3>4. Právní základ zpracování</h3>
            <p>Osobní údaje zpracováváme na základě:</p>
            <ul>
              <li><strong>Vašeho souhlasu</strong> - při vyplnění kontaktního formuláře</li>
              <li><strong>Legitimního zájmu</strong> - pro účely komunikace ohledně našich služeb</li>
              <li><strong>Plnění smlouvy</strong> - při uzavření smlouvy o výuce v autoškole</li>
            </ul>
          </div>

          <div className="gdpr-block">
            <h3>5. Doba uchování osobních údajů</h3>
            <p>Vaše osobní údaje uchováváme:</p>
            <ul>
              <li><strong>Poptávky</strong> - po dobu 2 let od posledního kontaktu</li>
              <li><strong>Studenti</strong> - po dobu vedení kurzu + 5 let (archivní účely)</li>
              <li><strong>Dokončené kurzy</strong> - po dobu 10 let (zákonná povinnost)</li>
            </ul>
          </div>

          <div className="gdpr-block">
            <h3>6. Vaše práva</h3>
            <p>V souvislosti se zpracováním vašich osobních údajů máte právo:</p>
            <ul>
              <li><strong>Na přístup</strong> k osobním údajům</li>
              <li><strong>Na opravu</strong> nepřesných údajů</li>
              <li><strong>Na výmaz</strong> údajů (právo být zapomenut)</li>
              <li><strong>Na omezení zpracování</strong></li>
              <li><strong>Na přenositelnost</strong> údajů</li>
              <li><strong>Vznést námitku</strong> proti zpracování</li>
              <li><strong>Odvolat souhlas</strong> se zpracováním</li>
            </ul>
            <p>Pro uplatnění vašich práv nás kontaktujte na emailu: <a href="mailto:josef.prikasky@seznam.cz">josef.prikasky@seznam.cz</a></p>
          </div>

          <div className="gdpr-block">
            <h3>7. Předávání údajů třetím stranám</h3>
            <p>Vaše osobní údaje nepředáváme třetím stranám, s výjimkou:</p>
            <ul>
              <li>Státních orgánů - pouze na základě zákonného požadavku</li>
              <li>Poskytovatelů IT služeb - za účelem technického zajištění provozu</li>
            </ul>
          </div>

          <div className="gdpr-block">
            <h3>8. Zabezpečení osobních údajů</h3>
            <p>Implementovali jsme vhodná technická a organizační opatření k ochraně vašich osobních údajů proti neoprávněnému přístupu, změně, zveřejnění nebo zničení.</p>
          </div>

          <div className="gdpr-block">
            <h3>9. Cookies</h3>
            <p>Naše webové stránky používají pouze technické cookies nezbytné pro fungování webu. Nepoužíváme analytické ani marketingové cookies.</p>
          </div>

          <div className="gdpr-block">
            <h3>10. Kontakt a stížnosti</h3>
            <p>Máte-li jakékoli dotazy ohledně zpracování vašich osobních údajů nebo chcete uplatnit svá práva, kontaktujte nás:</p>
            <div className="contact-info">
              <p>Email: <a href="mailto:josef.prikasky@seznam.cz">josef.prikasky@seznam.cz</a></p>
              <p>Telefon: <a href="tel:728108824">728 108 824</a></p>
            </div>
            <p>V případě nespokojenosti se zpracováním vašich osobních údajů máte právo podat stížnost u Úřadu pro ochranu osobních údajů.</p>
          </div>
        </div>

        <div className="gdpr-cta">
          <div className="cta-content">
            <h3>Máte dotazy ohledně GDPR?</h3>
            <p>Rádi vám zodpovíme jakékoliv otázky týkající se zpracování vašich osobních údajů</p>
            <div className="cta-buttons">
              <a href="mailto:josef.prikasky@seznam.cz" className="btn btn-primary">
                <span className="btn-icon">✉️</span>
                Napsat email
              </a>
              <a href="/" className="btn btn-secondary">
                <span className="btn-icon">←</span>
                Zpět na hlavní stránku
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Background decorations */}
      <div className="gdpr-background">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>
      </div>
    </div>
  )
}

export default GDPR